import axios from './../constants/axios';
import * as types from './../constants/actionTypes';
import { reset, SubmissionError } from 'redux-form';
import alert from 'alertify.js';

export function loadAllFeatureClassesSuccess(payload) {
   return { type: types.LOAD_FEATURE_CLASSES_SUCCESS, payload };
}

export function saveNewFeatureClassSuccess(payload) {
   return { type: types.SAVE_NEW_FEATURE_CLASS_SUCCESS, payload };
}

export function saveNewFeatureSuccess(payload) {
   return { type: types.SAVE_NEW_FEATURE_SUCCESS, payload };
}


export function loadAllFeatureClasses() {
   return function (dispatch) {
      return axios
         .get('featureClasses/getFeatureClassesWithFeatures')
         .then(function (res) {
            dispatch(loadAllFeatureClassesSuccess({
               featureClasses: res.data
            }));
         });
   };
}

export function saveNewFeatureClass(featureClass) {
   return function (dispatch) {
      return axios
         .post('featureClasses', featureClass)
         .then((res) => {
            dispatch(saveNewFeatureClassSuccess({
               featureClass: res.data
            }));
            alert.success('Feature Class Saved');
            dispatch(reset('newFeatureClass'));
         })
         .catch((err) => {
            throw  new SubmissionError(err.response.data);
         });
   };
}



/** WEBPACK FOOTER **
 ** ./src/actions/featureClassActions.js
 **/